import { GetServerSidePropsContext } from 'next'

export abstract class BaseService {
  context?: GetServerSidePropsContext

  constructor(context?: GetServerSidePropsContext) {
    this.context = context
  }
}
